<p-dialog
  [(visible)]="visible"
  (onHide)="onHide()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [style]="{ width: '95vw', maxWidth: '1040px' }"
  [contentStyle]="{ overflow: 'hidden', padding: 0 }"
  [class]="'profile-settings-dialog'"
>
  <ng-template pTemplate="header">
    <div class="settings-dialog-header">
      <h2 class="settings-dialog-title">{{ CONSTANTS.PROFILE_SETTINGS_TITLE | translate }}</h2>
      <p class="settings-dialog-subtitle">{{ CONSTANTS.PROFILE_SETTINGS_SUBTITLE | translate }}</p>
    </div>
  </ng-template>

  <div class="settings-shell">
    <aside class="settings-sidebar">
      <nav class="settings-nav" aria-label="Profile settings sections">
        @for (item of settingsSidebarItems; track item.id) {
          <button
            type="button"
            class="settings-nav-item"
            [class.settings-nav-item--active]="activeSection === item.id"
            (click)="selectSection(item.id)"
          >
            <i [class]="item.icon + ' settings-nav-icon'" aria-hidden="true"></i>
            <span class="settings-nav-label">{{ item.labelKey | translate }}</span>
          </button>
        }
      </nav>
    </aside>

    <div class="settings-main">
      @switch (activeSection) {
        @case ('personal') {
          <div class="settings-panel">
            @if (personalSectionLoading) {
              <div class="personal-section-loading" role="status" aria-live="polite">
                <p-progressSpinner strokeWidth="4" aria-hidden="true" />
              </div>
            } @else {
            <div class="personal-subsection">
              <div class="settings-panel-head">
                <h3 class="settings-panel-title">{{ CONSTANTS.PROFILE_SETTINGS_PERSONAL_TITLE | translate }}</h3>
                <p class="settings-panel-subtitle">{{ CONSTANTS.PROFILE_SETTINGS_PERSONAL_SUBTITLE | translate }}</p>
              </div>

              <div class="personal-photo-row">
                <p-avatar
                  [image]="avatarImageUrl ?? undefined"
                  [label]="avatarImageUrl ? undefined : avatarInitials"
                  size="xlarge"
                  shape="circle"
                  class="personal-avatar"
                ></p-avatar>
                <!--
                TODO: profile photo upload/remove — restore when backend supports it
                <div class="personal-photo-actions">
                  <input
                    #photoInput
                    type="file"
                    accept="image/*"
                    class="sr-only"
                    (change)="onPhotoFile($event)"
                  />
                  <button
                    pButton
                    type="button"
                    severity="primary"
                    icon="pi pi-upload"
                    class="profile-settings-accent-btn"
                    [label]="CONSTANTS.PROFILE_SETTINGS_UPLOAD_PHOTO | translate"
                    (click)="triggerPhotoSelect(photoInput)"
                  ></button>
                  <button
                    pButton
                    type="button"
                    severity="secondary"
                    [outlined]="true"
                    [label]="CONSTANTS.PROFILE_SETTINGS_REMOVE_PHOTO | translate"
                    (click)="removePhoto()"
                  ></button>
                </div>
                <p class="photo-hint">{{ CONSTANTS.PROFILE_SETTINGS_PHOTO_HINT | translate }}</p>
                -->
              </div>

              <div class="form-grid">
                <div class="field">
                  <label class="field-label" for="pf-first">{{ CONSTANTS.PROFILE_SETTINGS_FIRST_NAME | translate }}</label>
                  <input
                    pInputText
                    id="pf-first"
                    class="w-full"
                    [(ngModel)]="personalForm.firstName"
                    autocomplete="given-name"
                  />
                </div>
                <div class="field">
                  <label class="field-label" for="pf-last">{{ CONSTANTS.PROFILE_SETTINGS_LAST_NAME | translate }}</label>
                  <input
                    pInputText
                    id="pf-last"
                    class="w-full"
                    [(ngModel)]="personalForm.lastName"
                    autocomplete="family-name"
                  />
                </div>
                <div class="field">
                  <label class="field-label" for="pf-email">{{ CONSTANTS.PROFILE_SETTINGS_EMAIL | translate }}</label>
                  <input
                    pInputText
                    id="pf-email"
                    class="w-full"
                    type="email"
                    [(ngModel)]="personalForm.email"
                    autocomplete="email"
                  />
                </div>
                @if (showPositionField) {
                <div class="field">
                  <label class="field-label" for="pf-pos">{{ CONSTANTS.PROFILE_SETTINGS_POSITION | translate }}</label>
                  <input
                    pInputText
                    id="pf-pos"
                    class="w-full field-input--disabled-display"
                    [ngModel]="personalForm.position"
                    disabled
                  />
                </div>
                }
                @if (showSoloBarEgnField) {
                <div class="field">
                  <label class="field-label" for="pf-bar-egn">{{ CONSTANTS.PROFILE_SETTINGS_BAR_NUMBER_EGN | translate }}</label>
                  <input
                    pInputText
                    id="pf-bar-egn"
                    class="w-full"
                    [(ngModel)]="soloBarEgnCombined"
                    autocomplete="off"
                  />
                </div>
                }
              </div>
            </div>

            <div class="panel-actions">
              <button
                pButton
                type="button"
                severity="primary"
                class="profile-settings-accent-btn"
                [label]="CONSTANTS.PROFILE_SETTINGS_SAVE | translate"
                [loading]="personalSaving"
                [disabled]="personalSaving || personalSectionLoading"
                (click)="savePersonal()"
              ></button>
            </div>
            }
          </div>
        }
        @case ('firm') {
          <div class="settings-panel">
            @if (firmBureauSectionLoading) {
              <div class="personal-section-loading" role="status" aria-live="polite">
                <p-progressSpinner strokeWidth="4" aria-hidden="true" />
              </div>
            } @else {
            <section class="firm-settings-block" aria-labelledby="firm-section-title">
              <div class="settings-panel-head firm-settings-head">
                <h3 class="settings-panel-title" id="firm-section-title">
                  {{ CONSTANTS.PROFILE_SETTINGS_FIRM_SECTION_TITLE | translate }}
                </h3>
                <p class="settings-panel-subtitle">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_SECTION_SUBTITLE | translate }}</p>
              </div>
              <div class="firm-logo-row">
                <div class="firm-logo-placeholder" aria-hidden="true">{{ firmLogoInitials }}</div>
                <!--
                TODO: firm logo upload/remove — restore when backend supports it
                <div class="firm-logo-actions">
                  <input
                    #firmLogoInput
                    type="file"
                    accept="image/*"
                    class="sr-only"
                  />
                  <button
                    pButton
                    type="button"
                    severity="primary"
                    icon="pi pi-upload"
                    class="profile-settings-accent-btn profile-settings-dark-btn"
                    [label]="CONSTANTS.PROFILE_SETTINGS_UPLOAD_LOGO | translate"
                  ></button>
                  <button
                    pButton
                    type="button"
                    severity="secondary"
                    [text]="true"
                    [label]="CONSTANTS.PROFILE_SETTINGS_REMOVE_LOGO | translate"
                  ></button>
                </div>
                -->
              </div>
              <div class="form-grid firm-form-grid">
                <div class="field field--full">
                  <label class="field-label" for="firm-name">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_NAME | translate }}</label>
                  <input
                    pInputText
                    id="firm-name"
                    class="w-full"
                    [class.field-input--disabled-display]="!canEditFirmSection"
                    [(ngModel)]="firmName"
                    [disabled]="!canEditFirmSection"
                  />
                </div>
                <div class="field" [class.field--full]="!showFirmBarNumberField">
                  <label class="field-label" for="firm-uic">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_UIC | translate }}</label>
                  <input
                    pInputText
                    id="firm-uic"
                    class="w-full"
                    [class.field-input--disabled-display]="!canEditFirmSection || isOfficeManager"
                    [(ngModel)]="firmUicDisplay"
                    [disabled]="!canEditFirmSection || isOfficeManager"
                  />
                </div>
                @if (showFirmBarNumberField) {
                <div class="field">
                  <label class="field-label" for="firm-bar">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_BAR_NUMBER | translate }}</label>
                  <input
                    pInputText
                    id="firm-bar"
                    class="w-full"
                    [class.field-input--disabled-display]="!canEditFirmSection"
                    [(ngModel)]="firmBarNumberDisplay"
                    [disabled]="!canEditFirmSection"
                  />
                </div>
                }
                <div class="field field--full">
                  <label class="field-label" for="firm-address">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_ADDRESS | translate }}</label>
                  <input
                    pInputText
                    id="firm-address"
                    class="w-full"
                    [class.field-input--disabled-display]="!canEditFirmSection"
                    [(ngModel)]="firmAddressLine"
                    [disabled]="!canEditFirmSection"
                  />
                </div>
                <div class="field field--full">
                  <label class="field-label" for="firm-repr">{{ CONSTANTS.PROFILE_SETTINGS_FIRM_REPRESENTATIVES | translate }}</label>
                  <input
                    pInputText
                    id="firm-repr"
                    class="w-full"
                    [class.field-input--disabled-display]="!canEditFirmSection"
                    [ngModel]="canEditFirmSection ? firmRepresentatives : firmRepresentativesDisplay"
                    (ngModelChange)="canEditFirmSection && (firmRepresentatives = $event)"
                    [disabled]="!canEditFirmSection"
                  />
                </div>
              </div>
            </section>

            <div class="panel-actions">
              <button
                pButton
                type="button"
                severity="primary"
                class="profile-settings-accent-btn"
                [label]="CONSTANTS.PROFILE_SETTINGS_SAVE | translate"
                [loading]="firmSaving"
                [disabled]="!canEditFirmSection || firmSaving || personalSectionLoading || firmBureauSectionLoading"
                (click)="saveFirm()"
              ></button>
            </div>
            }
          </div>
        }
        @case ('team') {
          <div class="settings-panel">
            <div class="team-head">
              <div>
                <h3 class="settings-panel-title">{{ CONSTANTS.PROFILE_SETTINGS_TEAM_TITLE | translate }}</h3>
                <p class="settings-panel-subtitle">{{ CONSTANTS.PROFILE_SETTINGS_TEAM_SUBTITLE | translate }}</p>
              </div>
              <button
                pButton
                type="button"
                severity="primary"
                class="profile-settings-accent-btn"
                icon="pi pi-user-plus"
                [label]="CONSTANTS.PROFILE_SETTINGS_TEAM_INVITE | translate"
                (click)="inviteMember()"
              ></button>
            </div>

            @if (teamSectionLoading) {
              <div class="personal-section-loading" role="status" aria-live="polite">
                <p-progressSpinner strokeWidth="4" aria-hidden="true" />
              </div>
            } @else {
            <div class="team-grid">
              @for (m of teamMembers; track m.id) {
                <div class="team-card">
                  <div class="team-card-top">
                    <p-avatar [label]="m.initials" shape="circle" size="large" class="team-avatar"></p-avatar>
                    <div class="team-card-text">
                      <div class="team-name-block">
                        <div class="team-name">{{ m.displayName }}</div>
                        @if (m.title) {
                          <div class="team-role">{{ m.title }}</div>
                        }
                      </div>
                      <div class="team-contact">
                        <span><i class="pi pi-envelope" aria-hidden="true"></i> {{ m.email || '—' }}</span>
                      </div>
                    </div>
                  </div>
                  @if (m.expertise.length) {
                  <div class="team-expertise">
                    @for (tag of m.expertise; track tag) {
                      <span class="expertise-pill">{{ tag }}</span>
                    }
                  </div>
                  }
                </div>
              }
            </div>
            }
          </div>
        }
        @default {
          <div class="settings-placeholder">
            <p>{{ CONSTANTS.PROFILE_SETTINGS_PLACEHOLDER | translate }}</p>
          </div>
        }
      }
    </div>
  </div>
</p-dialog>
